import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-why-choose-a-bachelor-of-commerce',
  templateUrl: './why-choose-a-bachelor-of-commerce.component.html',
  styleUrls: ['./why-choose-a-bachelor-of-commerce.component.scss']
})
export class WhyChooseABachelorOfCommerceComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;


  ngOnInit(): void {
  }

}
